// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"be781be7","91":"6217985b","337":"823fb21f","535":"3a1e6e10","565":"c49fb2fa","634":"ba92c075","657":"3cb952a2","660":"4d338949","666":"dae44a88","781":"b59d7435","874":"e0e5bd6d","902":"98a4412e","972":"b64427f6","998":"2b36dbb6"}[chunkId] + ".chunk.js";
};